export const GET_HOSPITALS_LIST_QUERY_KEY = "GET_HOSPITALS_LIST_QUERY_KEY";
export const GET_HOSPITAL_DETAIL_QUERY_KEY = "GET_HOSPITAL_DETAIL_QUERY_KEY";
export const GET_TENANT_HOSPITAL_LIST_QUERY_KEY =
  "GET_TENANT_HOSPITAL_LIST_QUERY_KEY";

export type SELECTED_HOSPITAL_STATE = Partial<HOSPITAL>;

export type HOSPITAL = {
  name: string;
  timeZone: string;
  uuid: string;
  tenantId: string;
  active: boolean;
  dayStartTime: string;
  noOfOts: number;
  noOfUsers: number;
  physicalAddress: string;
  city: string;
  country: string;
  state: string;
  emrStatus?: string;
};

export type TENANT_HOSPITAL = {
  tenantId: string;
  tenantName: string;
  active?: boolean;
  hospitals: HOSPITAL[];
  totalHospitals?: number;
};
